import {createMuiTheme} from '@material-ui/core/styles'

export default createMuiTheme({
    palette: {
        primary: {
            dark: '#162D50',
            main: '#1A417F',
            light: '#165ECF'
        }
    },
    typography: {
        fontFamily: 'chivo bold, sans-serif'
    }
})
